namespace $.$$ {

	if( typeof $mol_dom_context !== 'undefined' && $mol_dom_context.document ) {

		const doc = $mol_dom_context.document

		const capture = ( event: Event )=> {

			$bog_tooltip_hush_off( doc )

			const tips = [] as HTMLElement[]
			let node = event.target instanceof $mol_dom_context.Element ? event.target : null

			for( ; node; node = node.parentElement ) {
				const title = node.getAttribute( 'title' )
				if( title ) {
					node.setAttribute( 'data-mol-tip', title )
					node.removeAttribute( 'title' )
				}
				if( node instanceof $mol_dom_context.HTMLElement && node.hasAttribute( 'data-mol-tip' ) ) tips.push( node )
			}

			const view = doc.documentElement.clientWidth
			const view_height = doc.documentElement.clientHeight
			const placed = tips.map( tip => [ tip, $bog_tooltip_room( tip.getBoundingClientRect(), view, view_height ) ] as const )

			for( const [ tip, room ] of placed ) {
				tip.style.setProperty( '--bog_tooltip_left', `${ room.left }px` )
				tip.style.setProperty( '--bog_tooltip_right', `${ room.right }px` )
				tip.style.setProperty( '--bog_tooltip_up', room.flip ? `calc( -100% - ${ room.lift }px )` : '0px' )
			}

		}

		const hush = ( event: Event )=> {
			if( ( event as KeyboardEvent ).key !== 'Escape' ) return
			$bog_tooltip_hush( doc.activeElement )
		}

		doc.addEventListener( 'mouseover', capture, true )
		doc.addEventListener( 'focusin', capture, true )
		doc.addEventListener( 'keydown', hush, true )

	}

	const shown = ( selector: string )=> `
		${ selector }::after {
			content: attr(data-mol-tip);
			position: absolute;
			z-index: 1000;
			top: calc(100% + 4px);
			left: 50%;
			width: max-content;
			max-width: min(80vw, 24rem);
			white-space: normal;
			overflow-wrap: anywhere;
			transform: translate(
				clamp(calc(8px - var(--bog_tooltip_left, 100vw)), -50%, calc(var(--bog_tooltip_right, 100vw) - 8px - 100%)),
				var(--bog_tooltip_up, 0px)
			);
			background: var(--mol_theme_card);
			color: var(--mol_theme_text);
			padding: 0.25rem 0.5rem;
			border-radius: 0.25rem;
			font-size: 0.75rem;
			line-height: 1.2;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
			pointer-events: none;
			animation: bog-tooltip-in 0.08s ease-out;
		}
	`

	$mol_style_attach( 'bog/tooltip/tooltip.view.css', `
		[data-mol-tip] {
			position: relative;
		}
		@media (hover: hover) and (pointer: fine) {
			${ shown( '[data-mol-tip]:hover' ) }
		}
		${ shown( '[data-mol-tip]:focus-visible:not([data-mol-tip-off])' ) }
		@keyframes bog-tooltip-in {
			from { opacity: 0; translate: 0 -2px; }
			to   { opacity: 1; translate: 0 0; }
		}
	`)

}
